import styled from "styled-components";
import { colours } from "../../../../../../styles/colours.constants";
import { satoshi700 } from "../../../../../../styles/font.constants";

export const Poll = styled.div<{ $hideSeperator: boolean }>`
	display: flex;
	flex-direction: column;
	padding-bottom: 1rem;
	margin-bottom: 1.5rem;
	border-bottom: ${({ $hideSeperator }) => {
		if ($hideSeperator) {
			return "none";
		}
		return `solid 1px ${colours.greyMedium}`;
	}};
`;

export const PollQuestion = styled.div`
	${satoshi700}
	font-size: 0.9rem;
	margin-bottom: 0.8rem;
`;

export const InputContainer = styled.div`
	width: 100%;
	margin: 1.5rem 0 0.4rem 0;
`;
